<script lang="ts">
	import {createEventDispatcher} from 'svelte';

	/** The key to listen for */
	export let key: string = null;
	export let disabled = false;
	export let borderColor = 'rgba(200, 200, 200, 1)';
	export let background = 'white';
	export let color = 'rgba(128, 128, 128, 1)';
	export let href: string = null;
	export let type: string = "button";


	const dispatch = createEventDispatcher();

	function handleKey(e: KeyboardEvent) {
		if (key && e.key === key) {
			dispatch('click');
		}
	}
</script>

<svelte:window on:keypress={handleKey}/>
{#if href}
	<a class="button" {href} class:disabled={disabled}>
		{#if $$slots['start-icon']}
			<span class="start-item start-item-icon">
				<slot name="start-icon"></slot>
			</span>
		{:else if $$slots.start}
			<span class="start-item">
				<slot name="start"></slot>
			</span>
		{/if}
		<span class="button-text" style="color: {color}">
			<slot></slot>
		</span>
	</a>
{:else}
	<button type="{type}" on:click={() => dispatch('click')}
			style="{disabled ? '' : `border-color: ${borderColor}; background: ${background}`}"
			{disabled}>
		{#if $$slots['start-icon']}
		<span class="start-item start-item-icon">
			<slot name="start-icon"></slot>
		</span>
		{:else if $$slots.start}
		<span class="start-item">
			<slot name="start"></slot>
		</span>
		{/if}
		<span class="button-text" style="color: {color}">
			<slot></slot>
		</span>
	</button>
{/if}

<style lang="scss">
	$start-item-offset: 12px;
	button, .button {
		all: unset; /* remove default styles */
		background: white;
		border: 1px solid rgba(200, 200, 200, 1);
		border-radius: 12px !important;

		display: flex;
		margin-left: $start-item-offset;

		&:hover:not([disabled]):not(.disabled) {
			cursor: pointer;
			.start-item {
				background: rgba(248, 185, 44, 1);
			}
		}
		&:focus:not([disabled]):not(.disabled) {
			box-shadow: var(--btn-focus-box-shadow);
		}
	}
	.start-item {
		border: 1px solid black;
		border-radius: 5px;
		color: black;

		font-family: 'Open Sans', sans-serif;
		font-size: 12px;
		font-weight: 600;
		//line-height: 12px;
		letter-spacing: 0;
		text-align: left;

		text-transform: uppercase;
		line-height: 1;
		margin: auto 0;
		padding: 8px;
		background-color: white;
		transform: translateX(-$start-item-offset);
	}
	.start-item.start-item-icon {
		line-height: 0;
	}
	.button-text {
		color: rgba(128, 128, 128, 1);
		font-family: 'Open Sans', sans-serif;
		font-style: normal;
		font-weight: 800;
		font-size: 24px;
		line-height: 33px;

		padding-top: 10px;
		padding-bottom: 10px;
		padding-right: 20px;
	}
</style>
